// https://react-component.github.io/badgeboard/
// https://github.com/react-component/checkbox?tab=readme-ov-file

import Form from 'rc-field-form'

export * from 'rc-field-form' // 把所有命名导出透传
export default Form
